import StyledLink from '../StyledLink'
import {
  DESIGNER,
  MODEL_HUB
} from '../routes'
import type { Props } from '../types'

const LinkToModelHub = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + DESIGNER + '/' + MODEL_HUB}
  >
    {children}
  </StyledLink>

export default LinkToModelHub
